import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import ComingSoon from '../../Pages/comingsoon/ComingSoon'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Campus Life"/>
        <ComingSoon pageName="Campus Life" />
    </>
  )
}

export default Main
